import { Download, FileText, Upload } from 'lucide-react';
import { useEffect, useState } from 'react';

import { API_URL } from '../../config/api'
interface Document { id: number; doc_type: string; title: string; content: string; created_at: string; agent_name?: string }
interface ProjectDocumentsProps { projectId: number }

export default function ProjectDocuments({ projectId }: ProjectDocumentsProps) {
  const [documents, setDocuments] = useState<Document[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const loadDocuments = async () => {
      try {
        const res = await fetch(`${API_URL}/api/projects/${projectId}/documents`)
        const data = await res.json()
        const docs = data.documents as Document[]
        setDocuments(docs || [])
      } catch (err) {
        console.error('Documents load error:', err)
      } finally {
        setLoading(false)
      }
    }
    void loadDocuments()
  }, [projectId])

  if (loading) {
    return <div style={{ padding: '20px', textAlign: 'center' }}>Loading...</div>
  }

  return (
    <div style={{ padding: '20px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
        <h2 style={{ display: 'flex', alignItems: 'center', gap: '12px', margin: 0 }}>
          <FileText size={24} /> Documents ({documents.length})
        </h2>
        <button style={{ padding: '10px 20px', borderRadius: '8px', border: 'none', background: 'linear-gradient(135deg, #667eea, #764ba2)', color: '#fff', fontSize: '14px', fontWeight: '600', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Upload size={16} /> Upload
        </button>
      </div>
      {documents.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '60px 20px', color: '#94a3b8' }}>
          <FileText size={64} style={{ opacity: 0.5, marginBottom: '16px' }} />
          <h3>No documents yet</h3>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {documents.map(doc => (
            <div key={doc.id} style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: '12px', padding: '20px', transition: 'all 0.2s', cursor: 'pointer' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <FileText size={20} style={{ color: '#667eea' }} />
                  <div>
                    <div style={{ fontWeight: '600', color: '#1a202c', marginBottom: '4px' }}>{doc.title}</div>
                    <div style={{ fontSize: '12px', color: '#94a3b8' }}>{doc.doc_type} • {new Date(doc.created_at).toLocaleDateString()}</div>
                  </div>
                </div>
                <button style={{ padding: '8px 16px', borderRadius: '8px', border: '1px solid #e2e8f0', background: '#fff', color: '#64748b', fontSize: '13px', fontWeight: '600', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <Download size={14} /> Download
                </button>
              </div>
              <div style={{ fontSize: '14px', color: '#64748b', lineHeight: '1.6' }}>
                {doc.content.substring(0, 200)}...
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
